<ng-template [ngIf]="!auth.validUser && validatingLogin">
    <a class="mvd_navbar__link user is-validating" role="button" href="javascript:void(0)"><i class="beacon--pending"></i> <b>Checking Status...</b></a>
</ng-template>
<ng-template [ngIf]="!auth.validUser && !validatingLogin">
    <a class="mvd_navbar__link user is-signedout" role="button" href="javascript:void(0)" (click)="redirectForLogin()"><i class="beacon--off"></i> <b>Login !</b></a>
</ng-template>

<ng-template [ngIf]="auth.validUser && !validatingLogin">
    <a dropdownToggle class="mvd_navbar__link dropdown-toggle"
        role="button" (click)="false"
        href="javascript:void(0)" title="{{ user.userName }}"
        aria-haspopup="true" aria-expanded="false">
        <i class="beacon--on"></i> <b>{{ user.name }}</b>
    </a>
    <ul *dropdownMenu class="dropdown-menu" role="menu">
        <li role="presentation"><a href="javascript:void(0)" title="Profile - {{ user.userName }}"><i class="material-icons">person</i><b>{{ user.userName }}</b></a></li>
        <li role="presentation"><a href="javascript:void(0)" title="Business Unit - {{businessUnitName}}" (click)="redirectForBusinessUnitSelection()"><i class="material-icons">gps_not_fixed</i><b>{{businessUnitName}}</b></a></li>

        <li role="presentation">
            <a href="javascript:void(0)" (click)="switchTheme()"><i class="material-icons">{{iconThemeType}}</i>{{themeSelectType}}</a>
        </li>

        <li role="presentation">
            <a href="javascript:void(0)" (click)="switchWideMode()"><i class="material-icons">{{iconWideMode}}</i>{{wideSelectType}}</a>
        </li>

        <li role="presentation"><a href="javascript:void(0)"><i class="material-icons">perm_device_information</i> Session Info</a></li>
        <li role="presentation"><a href="javascript:void(0)" (click)="redirectForLogout()"><i class="material-icons">power_settings_new</i> Logout</a></li>
    </ul>

    <div class="bottom-fixed">
        <ul class="info-bar">
            <li class="info-bar__left">
                <a class="back-to-top" href="javascript:void(0)" (click)="backToTop()"><i class="material-icons">vertical_align_top</i> Back to Top</a>
                <div class="client-time"><i class="material-icons icon--footer">access_time</i> {{clientTime}}</div>
            </li>
            <li>
                {{businessUnitName}}
            </li>
            <li class="info-bar__right">
                <div class="client-date"><i class="material-icons icon--info-bar">date_range</i> {{clientDate}}</div>
            </li>
        </ul>
    </div>
</ng-template>